import { BsFillBootstrapFill } from 'react-icons/bs'

export const BootstrapTech = () => {
    return (
        <div>
        <BsFillBootstrapFill />
        <h4>Bootstrap</h4>
        </div>
    )
}